module.exports = __webpack_public_path__ + "img/main_home_phone_fr.d20992b.png";